import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './guards';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'statements',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    loadChildren: () =>
      import('../app/modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'statements',
    title: 'Statements',
    loadChildren: () =>
      import('../app/modules/statement/statement.module').then(m => m.StatementModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'audit-center',
    title: 'Audit Center',
    loadChildren: () =>
      import('./modules/audit-center/audit-center.module').then(m => m.AuditCenterModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'erp-integration',
    title: 'ERP Integration',
    loadChildren: () =>
      import('./modules/erp-integration/erp-integration.module').then(m => m.ErpIntegrationModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'import-ap-transactions',
    title: 'Import AP Transactions',
    loadChildren: () =>
      import('./modules/import-ap-transactions/import-ap-transactions.module').then(m => m.ImportApTransactionsModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'email-setting',
    title: 'Settings',
    loadChildren: () =>
      import('../app/modules/setting/setting.module').then(m => m.SettingModule),
    canActivate: [ AuthGuard ]
  },
  {
    // Build brief 01 — Unified Sign-Up Flow with ERP Routing (post-Kinde refactor).
    // Customer onboarding lives behind AuthGuard now: customers authenticate via
    // Kinde first, then get routed here to pick their ERP / queue a custom one.
    path: 'onboarding',
    title: 'Onboarding',
    loadChildren: () =>
      import('./modules/onboarding-erp/onboarding-erp.module').then(m => m.OnboardingErpModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: '**',
    title: 'Page Not Found',
    component: NotFoundComponent,
  }
];

const config: ExtraOptions = {
  useHash: false,
  preloadingStrategy: PreloadAllModules
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}